<div class="text-area">
  <label *ngIf="label" class="form-label" [for]="inputId"
    >{{ label }}
    <span *ngIf="helperText" class="helper-text">({{ helperText }})</span>
  </label>
  <div [class.textarea-copy-wrapper]="showCopy">
    <textarea
      #textarea
      type="textarea"
      class="form-control input-field"
      [id]="inputId"
      [placeholder]="placeholder"
      [value]="value"
      [disabled]="disabled"
      [class.input-has-error]="isInvalid"
      [class.has-copy-icon]="showCopy"
      (input)="onInputChange($event)"
    ></textarea>
    <div
      *ngIf="showCopy"
      class="textarea-copy-icon"
      tabindex="0"
      role="button"
      aria-label="Copy to clipboard"
      (click)="copyToClipboard()"
    >
      <span [innerHTML]="trustedCopyIcon"></span>
    </div>
  </div>
  <ng-content select=".helper-message" />
  <span *ngIf="isInvalid" class="error-msg">
    {{ getErrorMessage() }}
  </span>
  <ng-content />
</div>
